import './typing-indicator.css';
import { Box, keychaine, useColorModeValue as mode } from '@chaine/keychaine';
import React from 'react';
export function TypingIndicator() {
    return (React.createElement(Box, { css: {
            '.typing-indicator': {
                backgroundColor: mode('#E6E7ED', '#1A202C'),
                width: 'auto',
                borderRadius: '50px',
                padding: '12px',
                display: 'table',
                margin: '0 auto',
                position: 'relative',
                WebkitAnimation: '2s bulge infinite ease-out',
                animation: '2s bulge infinite ease-out'
            },
            '.typing-indicator:after': {
                height: '10px',
                width: '10px',
                left: '-10px',
                bottom: '-10px'
            },
            '.typing-indicator span': {
                height: '8px',
                width: '8px',
                cssFloat: 'left',
                margin: '0 1px',
                backgroundColor: '#9E9EA1',
                display: 'block',
                borderRadius: '50%',
                opacity: 0.4
            },
            '.typing-indicator span:nth-of-type(1)': {
                WebkitAnimation: '1s blink infinite 0.3333s',
                animation: '1s blink infinite 0.3333s'
            },
            '.typing-indicator span:nth-of-type(2)': {
                WebkitAnimation: '1s blink infinite 0.6666s',
                animation: '1s blink infinite 0.6666s'
            },
            '.typing-indicator span:nth-of-type(3)': {
                WebkitAnimation: '1s blink infinite 0.9999s',
                animation: '1s blink infinite 0.9999s'
            },
            '@-webkit-keyframes blink': { '50%': { opacity: 1 } },
            '@keyframes blink': { '50%': { opacity: 1 } },
            '@-webkit-keyframes bulge': {
                '50%': { WebkitTransform: 'scale(1.05)', transform: 'scale(1.05)' }
            },
            '@keyframes bulge': {
                '50%': { WebkitTransform: 'scale(1.05)', transform: 'scale(1.05)' }
            },
            html: { display: 'table', height: '100%', width: '100%' },
            body: { display: 'table-cell', verticalAlign: 'middle' }
        } },
        React.createElement(keychaine.div, { className: "typing-indicator" },
            React.createElement(keychaine.span, null),
            React.createElement(keychaine.span, null),
            React.createElement(keychaine.span, null))));
}
